var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import * as Option from "fp-ts/lib/Option";
import styled from "styled-components";
import { config } from "core/utils";
import { mq } from "core/styles/snippets";
import { MarketingBanner } from "core/components";
function isCompatible(program) {
    return program.banner !== null;
}
export var block = function (program) {
    if (!isCompatible(program))
        return Option.none;
    return Option.some({
        key: config.blockKeys.marketingBanner,
        View: function () { return (React.createElement(Container, null,
            React.createElement(MarketingBanner, { banner: program.banner, trackingEnabled: !program.fetchingData }))); },
    });
};
var Container = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 120rem;\n  margin: 0 auto;\n  padding: 0 1rem;\n\n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  ", " {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n"], ["\n  width: 100%;\n  max-width: 120rem;\n  margin: 0 auto;\n  padding: 0 1rem;\n\n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  ", " {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n"])), mq.minWidth("48rem"), mq.minWidth("64rem"), mq.minWidth("90rem"));
var templateObject_1;
